import { Injectable } from "@angular/core";
import { AbstractControl, AsyncValidator, ValidationErrors } from "@angular/forms";
import { HospitalLicenseService } from "app/services/license/hospital/hospital-license.service";
import { Observable, of } from "rxjs";
import { map, catchError } from "rxjs/operators";

@Injectable({ providedIn: 'root' })

export class HospitalChiefNurseValidator implements AsyncValidator {
  // consumers can (re)assign this any time, even after binding to a control
  licenseId: string = '';

  constructor(private service: HospitalLicenseService){}

  validate(
    control: AbstractControl
  ): Observable< ValidationErrors | null > {
    return this.service.checkDuplicateChiefNurseName(control.value, this.licenseId).pipe(
      map(invalid => (
        invalid ? { invalidChiefNurseName: true} : null
        )),
      catchError(() => of(null))
    )
  }
}
